import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const deleteBatch = createAsyncThunk<void, string, { extra: Partial<Dependencies> }>(
  "batches/deleteBatch",
  async (batchId: string, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.deleteBatch(batchId);
  },
);

export const resetDeleteBatch = createAction("batches/resetDeleteBatch");
